import { JSONEditor } from '@json-editor/json-editor'

const BaseEditor = JSONEditor.defaults.editors.checkbox

class CheckboxEditor extends BaseEditor {
  constructor (options, defaults) {
    super(options, defaults)
    this.isBasic = options.jsoneditor.options.isBasic || false
    if (this.isBasic && this.options.displayInBasic !== true) {
      this.options.hidden = true
    }
  }
  // overriding this checkDependency method so that it correctly evalutuates false values of other boolean fields
  // not implementing globally because it's not clear if this is a bug in the library or not.
  // plus, to implement globally we'd need to loop through JSONEditor.defaults.editors and override the method in the prototype of each editor
  checkDependency (path, choices) {
    if (this.path === path || this.jsoneditor === null) {
      return
    }

    const editor = this.jsoneditor.getEditor(path)
    const value = editor ? editor.getValue() : undefined

    if (!editor) {
      this.dependenciesFulfilled = false
    // if the choice is a boolean and both choices and value are falsey,
    } else if (typeof choices === 'boolean' && !choices && (value === false || value === undefined)) {
      this.dependenciesFulfilled = true
    } else if (Array.isArray(choices)) {
      this.dependenciesFulfilled = choices.some(choice => {
        if (JSON.stringify(value) === JSON.stringify(choice)) {
          return true
        }

        return false
      })
    } else if (typeof choices === 'object') {
      if (typeof value !== 'object') {
        this.dependenciesFulfilled = choices === value
      } else {
        Object.keys(choices).some(key => {
          if (!hasOwnProperty(choices, key)) {
            return false
          }
          if (!hasOwnProperty(value, key) || choices[key] !== value[key]) {
            this.dependenciesFulfilled = false
            return true
          }

          return false
        })
      }
    } else if (typeof choices === 'string' || typeof choices === 'number') {
      this.dependenciesFulfilled = this.dependenciesFulfilled && value === choices
    } else if (typeof choices === 'boolean') {
      if (choices) {
        this.dependenciesFulfilled = this.dependenciesFulfilled && (value || value?.length)
      } else {
        this.dependenciesFulfilled = this.dependenciesFulfilled && (!value || value.length === 0)
      }
    }
  }
}

export default CheckboxEditor
